/**
 * A mixin to import display strings into an app
 */
import strings from '@/../../shared/src/strings.json'

export default {
  name: 'Strings',

  data () {
    return {
      'strings': strings
    }
  }
}
